module.exports = {"id":"s2-q1","text":"Have you attended secondary or tertiary education in the past 5 years?","multiselect":false,"options":[{"id":"s2-q1-a1","text":"Yes","next":"s2-q2","baseline":4,"focusAreaBaseline":4,"capability":0,"access":0},{"id":"s2-q1-a2","text":"No","next":"s2-q2","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q1.json
// module id = 906
// module chunks = 32